import React, { FC, useState } from 'react';
import { Box, Button, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { SpacingLayout } from 'components/atoms';
import { animated, useSpring } from 'react-spring';
import {
  animationText,
  animationTitle,
  hideAnimationText,
  hideAnimationTitle,
  showAnimationText,
  showAnimationTitle,
} from 'utils/animations/layout';
import IsVisible from 'react-visibility-sensor';

interface CarrierQuoteSectionProps {
  title: string;
  text: string;
  linkBtn: { text: string; link: string };
}

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    textTransform: 'uppercase',
    marginBottom: 5,
    [theme.breakpoints.up('sm')]: {
      fontSize: 32,
    },
  },
  text: {
    maxWidth: 335,
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
    },
  },
}));

const CarrierQuoteSection: FC<CarrierQuoteSectionProps> = ({ text, title, linkBtn }) => {
  const classes = useStyles();

  const scrollToSize = () => {
    document.getElementById(linkBtn.link).scrollIntoView();
  };
  const [isVisible, setIsVisible] = useState(false);

  return (
    <SpacingLayout>
      <IsVisible onChange={(active) => active && setIsVisible(true)}>
        <Container maxWidth={false} fixed>
          <Grid container spacing={8} justify={'center'}>
            <Grid item>
              <animated.div style={isVisible ? showAnimationTitle('300ms') : hideAnimationTitle}>
                <Typography className={classes.title} variant="h2" align={'center'} component={'h2'} color={'textPrimary'}>
                  <span>{title}</span>
                </Typography>
              </animated.div>
              <animated.div style={isVisible ? showAnimationText('600ms') : hideAnimationText}>
                <Typography className={classes.text} variant="body1" align={'center'} component={'h3'} color={'textPrimary'}>
                  {text}
                </Typography>
              </animated.div>
            </Grid>
          </Grid>
          <Grid container spacing={8} justify={'center'}>
            <Grid item>
              <animated.div style={isVisible ? showAnimationText('750ms') : hideAnimationText}>
                <Button color="primary" variant="contained" onClick={scrollToSize}>
                  {linkBtn.text}
                </Button>
              </animated.div>
            </Grid>
          </Grid>
        </Container>
      </IsVisible>
    </SpacingLayout>
  );
};

export default CarrierQuoteSection;
